import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Apps as DashboardIcon,
    FormatListBulletedOutlined as ListOutlinedIcon,
    Tune as GlobalSetupIcon,
    Storage as DataSetManagerIcon,
    Notifications,
} from '@material-ui/icons';
import { SidebarMenu, SidebarMenuItem } from '@commonClient2/components';
import { GLOBAL_SETUP_ROUTE } from '../GlobalSetup';
import { DATA_SET_MANAGER_ROUTE } from '../DataSetManager';
import { NOTIFICATION_TEMPLATES_ROUTE } from '../NotificationTemplates';

/**
 * @param {{
 *  title: string;
 *  onIconTitleClick?: Function;
 * }} param0
 */
const AdminSidebar = ({
    title,
    onIconTitleClick,
}) => {
    const { t } = useTranslation('menu', { keyPrefix: 'admin' });
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const [basePath] = pathname.match(/[^/]+/g) || []; // Get first part of path, ex: /admin/dashboard => admin

    const dashboardRoute = `/${basePath}`;
    const globalSetupRoute = `${dashboardRoute}${GLOBAL_SETUP_ROUTE}`;
    const dataSetManagerRoute = `${dashboardRoute}${DATA_SET_MANAGER_ROUTE}`;
    const notificationTemplatesRoute = `${dashboardRoute}${NOTIFICATION_TEMPLATES_ROUTE}`;
    const canShowNotificationManagerNavigation = useSelector((/** @type {ShiftBidding.ShiftBiddingStore} */ state) => state.publicConfigs.isNotificationManagerPageExist);
    const canShowDataSetManagerNavigation = useSelector((/** @type {ShiftBidding.ShiftBiddingStore} */ state) => state.publicConfigs.isDataSetManagerPageExist);

    return (
        <div className="admin--sidebar">
            <SidebarMenu
                title={title}
                icon={<ListOutlinedIcon />}
                onIconTitleClick={onIconTitleClick}
            >
                <SidebarMenuItem
                    icon={<DashboardIcon />}
                    isActive={dashboardRoute === pathname}
                    onClick={() => navigate(dashboardRoute)}
                    label={t('dashboard')}
                />
                <SidebarMenuItem
                    icon={<GlobalSetupIcon />}
                    isActive={globalSetupRoute === pathname}
                    onClick={() => navigate(globalSetupRoute)}
                    label={t('globalSetup')}
                />
                {canShowNotificationManagerNavigation && (
                    <SidebarMenuItem
                        icon={<Notifications />}
                        isActive={notificationTemplatesRoute === pathname}
                        onClick={() => navigate(notificationTemplatesRoute)}
                        label={t('notificationManager')}
                    />
                )}
                {canShowDataSetManagerNavigation && (
                    <SidebarMenuItem
                        icon={<DataSetManagerIcon />}
                        isActive={dataSetManagerRoute === pathname}
                        onClick={() => navigate(dataSetManagerRoute)}
                        label={t('dataSetManager')}
                    />
                )}
            </SidebarMenu>
        </div>
    );
};

export default AdminSidebar;
